// The one label every sign-up button on the marketing surface carries: the
// landing page's buttons and the marketing header's, phone and desktop
// (founder pick A, 2026-09-29: "Start free" everywhere). Import-free, so the
// header on every public page can read it without pulling anything else in.
export const START_FREE = 'Start free';
